import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from '@material-ui/core'
import { Form, Formik } from 'formik'
import { alterarStatus } from 'src/modules/contratos/hooks/tabela/tabelaSubRepository'
import { AlterarStatusTabelaContratoData } from 'src/modules/contratos/types/tabelaTypes'
import snackbarStore from 'src/stores/snackbar'
import SelectInput from '../Formik/Forms/SelectInput'

interface TabelasContratoDialogProps {
  open: boolean
  handleClose: () => void
  primaryAction?: () => void
  status: string
  optionsStatus: string[]
  contratoId: string
  tabelaId: string
}

const initialValues: AlterarStatusTabelaContratoData = {
  newStatus: 'INATIVO'
}

function TabelasContratoDialog({
  open,
  handleClose,
  primaryAction,
  status,
  optionsStatus,
  contratoId,
  tabelaId
}: TabelasContratoDialogProps) {
  const handlePrimaryAction = () => {
    handleClose()
    primaryAction && primaryAction()
  }

  function getOptions(optionsStatus: string[]) {
    const options = optionsStatus.map((value: string) => {
      return { label: value, value }
    })
    return options
  }

  const handleSubmit = async (data: AlterarStatusTabelaContratoData) => {
    const res = await alterarStatus(contratoId, tabelaId, data)
    if (res.ok) {
      snackbarStore.setMessage('Status alterado com sucesso!')
      window.location.reload()
    } else {
      snackbarStore.setMessage(
        res.data?.message ?? 'Error ao alterar status da Tabela.'
      )
    }
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">Editar Status</DialogTitle>
      <DialogContent>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ handleSubmit, isSubmitting, values }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <SelectInput
                    name="newStatus"
                    label="Selecionar Status"
                    options={getOptions(optionsStatus)}
                  />
                </Grid>
              </Grid>
              <Grid container justifyContent="flex-end">
                <DialogActions>
                  <Button onClick={handleClose} color="default" autoFocus>
                    Voltar
                  </Button>
                  <Button
                    onClick={handlePrimaryAction}
                    disabled={!!!values.newStatus || isSubmitting}
                    color="primary"
                    type="submit"
                    autoFocus
                  >
                    Confirmar
                  </Button>
                </DialogActions>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default TabelasContratoDialog
